import { render, staticRenderFns } from "./WheelNumbers.vue?vue&type=template&id=1da5595b&scoped=true&"
import script from "./WheelNumbers.vue?vue&type=script&lang=js&"
export * from "./WheelNumbers.vue?vue&type=script&lang=js&"
import style0 from "./WheelNumbers.vue?vue&type=style&index=0&id=1da5595b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5595b",
  null
  
)

export default component.exports